"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_mergewith_1 = __importDefault(require("lodash.mergewith"));
function mergeCopyArrays(objValue, srcValue) {
    if (Array.isArray(objValue)) {
        return srcValue;
    }
}
/**
 * pureMerge merges given sources into one and returns it
 * as a new object without modifiyng existing ones.
 *
 * You can pass a single type e.g. `pureMerge<MyType>()` then
 * the first argument must match the type fully while the other
 * should match it partially.
 *
 * You can also pass types for each of the arguments.
 */
function pureMerge(...sources) {
    return lodash_mergewith_1.default({}, ...sources, mergeCopyArrays);
}
exports.default = pureMerge;
